<div class="signup-completed-container">
  <div class="content-wrapper">
    <img class="logo-img" src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />

    <!-- Content when account is created by carrier -->
    @if (isFromCarrier) {
      <div class="success-title">🎉 Welcome to FleetOperate</div>

      <div class="account-active-text">
        Your account has been created!
      </div>

      <div class="info-box">
        <div class="info-header">
          Your account was set up by a <span class="bold">carrier company.</span>
        </div>
        <div class="info-text">
          To get started, you'll need to set your password:
        </div>
        <ol class="info-list">
          <li>Click "Set Your Password" below</li>
          <li>Enter your email address</li>
          <li>Check your email for a secure link</li>
          <li>Create your new password</li>
        </ol>
        <div class="info-text">
          Once complete, you can sign in and start your application.
        </div>
      </div>

      <button mat-raised-button color="primary" class="go-to-sign-in-button" (click)="goToResetPassword()">
        Set Your Password
      </button>
    }

    <!-- Content when driver self-signs up (normal flow) -->
    @if (!isFromCarrier) {
      <div class="success-title">🎉 Account Activated</div>

      <div class="account-active-text">
        Your FleetOperate account is now<br />Active!
      </div>

      <div class="info-box">
        <div class="info-header">
          To apply for a <span class="bold">specific Trucking Company:</span>
        </div>
        <ul class="info-list">
          <li>Click the application link you received from the Company.</li>
          <li>Log in using your FleetOperate account.</li>
          <li>Complete all required profile sections.</li>
        </ul>
      </div>

      <button mat-raised-button color="primary" class="go-to-sign-in-button" (click)="goToSignIn()">
        Go to Sign In
      </button>
    }
  </div>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>